import profileDefault from "@/assets/profile-new.json";
import { deepCopy } from "@/utils";

const state = {
  fileName: "AM",
  data: deepCopy(profileDefault),
  default: deepCopy(profileDefault),
};

const actions = {
  setFileName({ commit }, fileName) {
    commit("SET_FILE_NAME", fileName);
  },
  setData({ commit }, data) {
    data.key_layer.layer_data.map(({ layer }) => {
      layer.map((item, index) => {
        layer[index] = item.toUpperCase();
      });
    });
    commit("SET_DATA", data);
  },
};

const mutations = {
  SET_FILE_NAME: (state, fileName) => {
    state.fileName = fileName;
  },
  SET_DATA: (state, data) => {
    state.data = data;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
